<nb-card [nbSpinner]="downloading"
nbSpinnerStatus="danger"
nbSpinnerSize="large"
nbSpinnerMessage="Descargando elemento">
  <nb-card-header >
    <nav class="navbar navigation">
      <div class="title-filter">
        <span><nb-icon [icon]="iconos[tipoReporte]" pack="font-awesome"></nb-icon> Informes de {{literalTipoInforme}}</span>
        <div class="cuadernos_pdf_group">
        <angular2-multiselect *ngIf="pdfCuadernoCampo" [data]=listaCuadernos [(ngModel)]="cuadernosPdf"
            [settings]="cuadernosSettings">
          </angular2-multiselect>
        <button *ngIf="pdfCuadernoCampo" [disabled]="cuadernosPdf.length == 0" class="space-left" nbButton shape="round" status="primary" (click)="descargarCuadernoPdf()"><nb-icon icon="cloud-download-outline"></nb-icon> Descargar cuaderno</button>
      </div>
      </div>

    </nav>
    <div class="row title-filter">
      <div class="form-group tipo col-2">
          <angular2-multiselect [data]=tiposInforme [(ngModel)]="tipoInformeSeleccionado"
            [settings]="dropdownSettings">
          </angular2-multiselect>
      </div>
      <span class="space-left">Fechas</span>
      <div class="form-group space-left">

        <input nbInput [nbDatepicker]="rangepicker" [(ngModel)]="fechasFiltro">
<nb-rangepicker #rangepicker format="dd/MM/yyyy"> </nb-rangepicker>
      </div>

      <div class="form-group tipo col-4">
        <angular2-multiselect [data]="usuarios" [(ngModel)]="usuarioSeleccionado" [settings]="usuarioDropdownSettings">

        </angular2-multiselect>

      </div>
      <button class="space-left" nbButton status="primary" shape="round" (click)="back()"><nb-icon icon="arrow-back"></nb-icon>
      </button>
      </div>
    <div class="row title-filter">

      <button class="space-left" nbButton shape="round" status="info" (click)="aplicar()"><nb-icon icon="search-outline"></nb-icon>
        Buscar </button>
        <button class="space-left" nbButton shape="round" status="success" (click)="limpiar()"><nb-icon icon="sync-outline"></nb-icon>
        Limpiar </button>
        <button *ngIf="tipoReporte == 'disease' || tipoReporte== 'maintenance'" [disabled]="source.count() == 0" class="space-left" nbButton shape="round" status="primary" (click)="exportarPdf()"><nb-icon icon="download-outline"></nb-icon>PDF<nb-icon icon="file-pdf" pack="font-awesome"></nb-icon></button>
        <button [disabled]="source.count() == 0" class="space-left" nbButton shape="round" status="primary" (click)="exportarXls()"><nb-icon icon="cloud-download-outline"></nb-icon>EXCEL<nb-icon icon="file-excel" pack="font-awesome"></nb-icon></button>
        <button *ngIf="(tipoReporte == 'sampling' || tipoReporte== 'notebook')" class="space-left" nbButton shape="round" status="primary" (click)="importarReportes()"><nb-icon icon="cloud-upload-outline"></nb-icon> Importar</button>


    </div>
  </nb-card-header>

  <nb-card-body  [nbSpinner]="loading"
  nbSpinnerStatus="danger"
  nbSpinnerSize="large"
  [nbSpinnerMessage]="loadingMessage">
  <div class="row">
    <div class="col-8">
      <ng2-smart-table *ngIf="tipoReporte == 'disease'" [settings]="tableSettings['disease']" [source]="source" (userRowSelect)="onReportSelected($event)"></ng2-smart-table>
      <ng2-smart-table *ngIf="tipoReporte == 'maintenance'" [settings]="tableSettings['maintenance']" [source]="source" (userRowSelect)="onReportSelected($event)"></ng2-smart-table>
      <ng2-smart-table *ngIf="tipoReporte == 'sampling'" [settings]="tableSettings['sampling']" [source]="source" (userRowSelect)="onReportSelected($event)"></ng2-smart-table>
      <ng2-smart-table *ngIf="tipoReporte=='notebook'" [settings]="tableSettings['notebook']" [source]="source" (userRowSelect)="onReportSelected($event)"></ng2-smart-table>
    </div>

    <div class="col-4">
      <div id="popup" *ngIf="informeSeleccionado != null" [hidden]="informeSeleccionado == null">
        <nb-card>
          <nb-card-header>

              <h3>{{informeSeleccionado.titulo}}</h3>
              <div class="align-right">
                <button nbButton size="small" status="danger" (click)="deleteReport()"><nb-icon icon="trash-2-outline"></nb-icon></button>
                <button *ngIf="reportEditionEnabled" nbButton size="small" status="success" (click)="cancelEdition()"><nb-icon icon="close-outline"></nb-icon></button>
                <button *ngIf="reportEditionEnabled" nbButton size="small" status="success" (click)="saveReport()"><nb-icon icon="save-outline"></nb-icon></button>
                <button *ngIf="!reportEditionEnabled" nbButton size="small" status="success" (click)="enableEdition()"><nb-icon icon="edit-outline"></nb-icon></button>
              </div>
          </nb-card-header>
          <nb-card-body [nbSpinner]="editingReport"
          nbSpinnerStatus="danger"
          nbSpinnerSize="large"
          nbSpinnerMessage="Procesando petición...">
              <ngx-disease-lite #diseaseReport *ngIf="informeSeleccionado.tipoInforme == 'disease'" [loadReport]="informeSeleccionado"></ngx-disease-lite>
              <ngx-maintenance-lite #maintenanceReport *ngIf="informeSeleccionado.tipoInforme == 'maintenance'" [loadReport]="informeSeleccionado"></ngx-maintenance-lite>
              <ngx-sampling-lite #samplingReport *ngIf="informeSeleccionado.tipoInforme == 'sampling'" [loadReport]="informeSeleccionado"></ngx-sampling-lite>
              <ngx-notebook-lite #notebookReport *ngIf="informeSeleccionado.tipoInforme == 'notebook'" [loadReport]="informeSeleccionado"></ngx-notebook-lite>
            </nb-card-body>
            <nb-card-footer class="space-between">
              <button nbButton size="small" status="danger" (click)="deleteReport()"><nb-icon icon="trash-2-outline"></nb-icon> Eliminar</button>
              <button *ngIf="reportEditionEnabled" nbButton size="small" status="success" (click)="cancelEdition()"><nb-icon icon="close-outline"></nb-icon> Cancelar</button>
              <button *ngIf="reportEditionEnabled" nbButton size="small" status="success" (click)="saveReport()"><nb-icon icon="save-outline"></nb-icon> Guardar</button>
              <button *ngIf="!reportEditionEnabled" nbButton size="small" status="success" (click)="enableEdition()"><nb-icon icon="edit-outline"></nb-icon> Editar</button>
            </nb-card-footer>
        </nb-card>

    </div>

    </div>


  </div>


  </nb-card-body>
</nb-card>

<ng-template #deleteDialog let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>Eliminar reporte</nb-card-header>
    <nb-card-body>Confirmas que quieres eliminar el reporte {{ data.tipoInforme }}</nb-card-body>
    <nb-card-footer>
    <div class="row">
      <div class="col-md-6">
        <button nbButton status="primary" (click)="ref.close()">Cancelar</button>
      </div>
      <div class="col-md-6 text-right">
        <button nbButton status="danger" (click)="ref.close();confirmarEliminarReporte(data.componente)">Eliminar</button>
      </div>
    </div>


    </nb-card-footer>
  </nb-card>
</ng-template>

<ng-template #confirmExport let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>Exportar informes</nb-card-header>
    <nb-card-body>Ha seleccionado más de 100 registros, su informe tardará unos minutos</nb-card-body>
    <nb-card-footer>
    <div class="row">
      <div class="col-md-6">
        <button nbButton status="info" (click)="ref.close();dismissLoading()">Cancelar</button>
      </div>
      <div class="col-md-6 text-right">
        <button nbButton status="primary" (click)="ref.close();confirmarExportar(data.tipo,data.elementos)">Aceptar</button>
      </div>
    </div>


    </nb-card-footer>
  </nb-card>
</ng-template>
